var exports = {
  "Y": "x4c3adb35--61f105--tooltip",
  "A": "x4c3adb35--61f105--item",
};

module.exports = exports;
